import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface FieldProps {
  label: string;
  value: any;
  path: string;
  type?: "text" | "number" | "textarea";
  setContent: (update: any) => void;
}

export function ResumeField({ label, value, path, type = "text", setContent }: FieldProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    let newValue: any = e.target.value;

    if (type === "number") {
      newValue = Number(newValue);
    }

    setContent({ type: "UPDATE_FIELD", path, value: newValue });
  };

  const fieldId = `resume-field-${path.replace(/\./g, "-")}`;

  return (
    <div className="mb-3">
      <Label htmlFor={fieldId}>{label}</Label>

      {type === "textarea" ? (
        <Textarea
          id={fieldId}
          value={value ?? ""}
          onChange={handleChange}
          className="mt-1"
        />
      ) : (
        <Input
          id={fieldId}
          type={type}
          value={value ?? ""}
          onChange={handleChange}
          className="mt-1"
        />
      )}
    </div>
  );
}
